export default __webpack_public_path__ + "static/media/loading-combined-short.374ce31f.mp3";